import { ProcessSignalNumber } from "Api/adminAgent/types/ProcessSignal.enum";

export const processSignals = [
  ProcessSignalNumber.SIGHUP,
  ProcessSignalNumber.SIGINT,
  ProcessSignalNumber.SIGQUIT,
  ProcessSignalNumber.SIGFPE,
  ProcessSignalNumber.SIGKILL,
  ProcessSignalNumber.SIGPIPE,
  ProcessSignalNumber.SIGALRM,
  ProcessSignalNumber.SIGTERM,
  ProcessSignalNumber.SIGCHLD
];
